/* jshint ignore:start */

var ReferencesManager = (function($) {

    var instance;

    function init() {

        var USE_CLUSTERS = false;

        var _$referencesCatsFilter;
        var _$referencesFilterMap;

        var activeFilterClass = 'btn-filter--selected';

        var _catsActives = [];
        var _locationActives = [];
        var _servicesActives = [];

        var isOpenServices = false;



        function initClientsModule() {

            initTabs();

            initDropdown();

            initServicesFilter();

            initLocationFilter();

            initFilters();

            initActionsReferences();
        }

        function initActionsReferences() {
            $('.js-ref-cat-item').on("click", function() {
                var idReference = $(this).data('id');

                var mapsManager = new MapsManager.getInstance();
                mapsManager.goToPoint(idReference);
            })
        }

        function initDropdown() {
            jQuery(document).ready(function (e) {
                function t(t) {
                    e(t).bind("click", function (t) {
                        t.preventDefault();
                        e(this).parent().fadeOut()
                    })
                }
                e(".js-dropdown-base").click(function () {
                    var t = e(this).parents(".dropdown-menu__base-content").children(".dropdown-menu__base-drop").is(":hidden");
                    e(".dropdown-menu__base-content .dropdown-menu__base-drop").hide();
                    e(".dropdown-menu__base-content .dropdown-menu__base-element").removeClass("active");
                    
                    var $tabsclient = $('.js-tabs-client-info');
                    if (t) {
                        e(this).parents(".dropdown-menu__base-content").children(".dropdown-menu__base-drop").toggle().parents(".dropdown-menu__base-content").children(".dropdown-toggle").addClass("active")

                        if (!($tabsclient.hasClass('block-scroll'))) {
                            $tabsclient.addClass('block-scroll');
                            isOpenServices = true;
                        }
                    } else {
                        $tabsclient.removeClass('block-scroll');
                        isOpenServices = false;
                    }
                    
                    
                });
                e(document).bind("click", function (t) {                    
                    var n = e(t.target);
                    if (!n.parents().hasClass("dropdown-menu__base-content")) {
                        e(".dropdown-menu__base-content .dropdown-menu__base-drop").hide();

                        if (isOpenServices) {
                            var $tabsclient = $('.js-tabs-client-info');
                            $tabsclient.removeClass('block-scroll');
                            isOpenServices = false;
                        }
                    }
                });
                e(document).bind("click", function (t) {                    
                    var n = e(t.target);
                    if (!n.parents().hasClass("dropdown-menu__base-content")) {
                        e(".dropdown-menu__base-content .dropdown-toggle").removeClass("active");

                        if (isOpenServices) {
                            var $tabsclient = $('.js-tabs-client-info');
                            $tabsclient.removeClass('block-scroll');
                            isOpenServices = false;
                        }
                    } 
                })
            });

            $('.js-close-dropdown').on("click", function(e) {
                e.preventDefault();
                // console.log('cerrando....');
                // $(this).closest(".js-dropdown-base").trigger("click");
                $('body').trigger("click");

                var $tabsclient = $('.js-tabs-client-info');
                $tabsclient.removeClass('block-scroll');
                isOpenServices = false;
            });
        }

        function initTabs() {
            $('.js-tabs-client-cats a').on('click', function(event){
                event.preventDefault();

                setCategory($(this));
            });
        }

        function initLocationFilter() {
            $(".js-location").click(function () {
                // $('.europe_option, .latin_option').toggleClass('u-hidden');
                if ($(this).data('id') == _locationActives[0]) {
                    return;
                }

                $('.europe, .latin').toggleClass('selected');
                refreshLocation();
                refreshFilters();
            });
        }

        function initServicesFilter() {
            $(".js-ref-filter-service").on("change", function () {
                var idService = parseInt($(this).val(), 10);

                if ($(this).prop("checked")) {
                    addService(idService);
                } else {
                    removeService(idService);
                }

                refreshFilters();
            });
        }

        function removeService(idService) {
            idService = parseInt(idService,10);
            
            const index = _servicesActives.indexOf(parseInt(idService,10));
            // console.log('index', index);
            if (index > -1) { 
                _servicesActives.splice(index, 1);
            }

            removeElementServiceFilter(idService);
        }

        function addService(idService) {
            const index = _servicesActives.indexOf(parseInt(idService, 10));
            if (index < 0) { 
                _servicesActives.push(parseInt(idService,10));

                addElementServiceFilter(idService);
            }
        }

        function addElementServiceFilter(idService) {
            var $label = $('#tab-'+  _catsActives[0]).find('.js-label-service-'+ idService);

            var html = '<li class="js-filter-service-item js-filter-service-item-'+ idService +'">'+
                    '<div class="tabs-client__info-filters-element">'+
                        '<div class="tabs-client__info-filters-element-left js-remove-service-filter" data-service="'+ idService +'">'+
                            '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">'+
                                '<path d="M16.759 1.241a.823.823 0 0 1 0 1.164L10.164 9l6.595 6.594a.823.823 0 0 1-1.164 1.165L9 10.163l-6.595 6.596a.825.825 0 0 1-1.164 0 .823.823 0 0 1 0-1.165L7.836 9 1.241 2.405a.823.823 0 0 1 1.164-1.164L9 7.836l6.594-6.595a.823.823 0 0 1 1.165 0z" fill="#666966" fill-rule="nonzero"/>'+
                            '</svg>'+
                        '</div>'+
                        '<div class="tabs-client__info-filters-element-right">'+
                            $label.text() +
                        '</div>'+
                    '</div>'+
                '</li>';

                $('#tab-'+  _catsActives[0]).find('.js-filters-services-list').append(html);

                $('.js-filter-service-item-'+ idService + ' .js-remove-service-filter').bind("click", function (e) {
                    var tmpService = $(this).data('service');
                    // console.log('eliminando....', tmpService);
                    removeService(tmpService);
                    changeServiceStatus(tmpService);
                });
        }

        function changeServiceStatus(idService) {
            $('#tab-'+  _catsActives[0]).find('.js-ref-filter-service-'+ idService).prop("checked", false);
        }

        function removeElementServiceFilter(idService) {
            $('#tab-'+  _catsActives[0]).find('.js-filter-service-item-'+ idService).remove();

            refreshFilters();
        }

        function initFilters($currentCat) {

            _servicesActives = [];

            refreshLocation();
            

            var $currentCat = $('.js-tabs-client-cats .active .js-filter-cat');
            _catsActives = [$currentCat.data('id')];            

            refreshFilters();
        }

        function refreshLocation() {
            _locationActives = [];
            var $locations = $('.js-location');
            $locations.each(function() {
                if ($(this).hasClass('selected')) {
                    _locationActives.push($(this).data('id'));
                }
            });
        }

        function setCategory($category) {

            var categoryId = $category.data('id');
            if (_catsActives.length && (_catsActives[0] == categoryId)) {
                return;
            }

            $('.js-tabs-client-cats li').removeClass('active');
            $category.parent().addClass('active');

            $('#tab-'+  _catsActives[0]).addClass('u-hidden');
            $('#tab-'+  categoryId).removeClass('u-hidden');
            
            resetFiltersWhenChangeCat();

            _catsActives[0] = categoryId;

            refreshFilters();

            
        }

        function resetFiltersWhenChangeCat() {
            $('#tab-'+  _catsActives[0]).find('.js-filter-service-item').remove();

            for (var i=0; i<_servicesActives.length; i++) {
                changeServiceStatus(_servicesActives[i]);
            }            

            _servicesActives = [];
        }

        function setCategoriesActives()
        {
            var $currentFilter;

            _catsActives = [];
            var $filters = jQuery('.js-filter-points');
            $filters.each(function () {
                $currentFilter = jQuery(this);

                if ($currentFilter.hasClass(activeFilterClass)) {
                    _catsActives.push($currentFilter.data('id'));
                }
            });

        }

        function refreshFilters() {
            var mapsManager = new MapsManager.getInstance();
            mapsManager.setLocations(_locationActives);
            mapsManager.setServices(_servicesActives);
            mapsManager.setCategories(_catsActives);

            mapsManager.updateItemsMapByFilter();
            mapsManager.renderList();

            refreshItems();
        }

        function hasServicesActiveItem($item) {
            if (_servicesActives.length == 0) {
                return true;
            }

            var dataServicesTxt = String($item.data('services'));
            var dataServices = dataServicesTxt.split(',');
            dataServices = dataServices.map(Number);


            var serviceTmp;
            var hasService = false;
            for (var i = 0; i < _servicesActives.length; i++) {
                serviceTmp = parseInt(_servicesActives[i],10);
                if (dataServices.indexOf(serviceTmp) >= 0) {
                    hasService = true;
                }
            }

            return hasService;
        }

        function hasLocationActiveItem($item) {            
            // return true;
            // console.log(item, _locationActives);
            if (_locationActives.length == 0) {
                return true;
            }

            var itemLocation = String($item.data('location'));

            var hasLocation = false;
            for (var i = 0; i < _locationActives.length; i++) {
                if (itemLocation == _locationActives[i]) {
                    hasLocation = true;
                }
            }

            return hasLocation;
        }

        function refreshItems() {
            var $emptyTxt = $('#tab-'+_catsActives[0]).find('.js-no-items');
            if (!$emptyTxt.hasClass('u-hidden')) {
                $emptyTxt.addClass('u-hidden')
            }

            var $items = $('#tab-'+_catsActives[0]).find('.js-ref-cat-item');

            var counter = 0;
            $items.each(function() {
                $item = $(this);

                if (hasServicesActiveItem($item) && hasLocationActiveItem($item)) {
                    $item.show();
                    counter++; 
                } else {
                    $item.hide();
                }
            });

            if (!counter) {
                $emptyTxt.removeClass('u-hidden');
            } 
        }

        return {

            init: function() {

                _$referencesCatsFilter = $('.js-ref-cat');

                if (_$referencesCatsFilter.length) {
                    initClientsModule();
                }
            },

            initFilterReferencesMap: function()
            {
                var ref = this;

                _$referencesFilterMap.on("click",function(e){
                    e.preventDefault();

                    var $ele = jQuery(this);

                    var color = $ele.data('color');

                    if ($ele.hasClass(activeFilterClass)) {
                        $ele.removeClass(activeFilterClass);
                        jQuery('.js-circle-'+color).hide();
                    } else {
                        $ele.addClass(activeFilterClass);
                        jQuery('.js-circle-'+color).show();
                    }

                    setCategoriesActives();
                    ref.updateItemsMapByFilter();
                });
            },

            updateItemsMapByFilter: function()
            {
                var $currentPoint;
                var $currentItem;
                var categories;
                var categoriesData;
                var numCats;
                var j;
                var visible;

                var $points = jQuery('.js-point');
                var $items;
                var pointVisible;


                $points.each(function () {
                    $currentPoint = jQuery(this);

                    $items = $currentPoint.find('.js-point-item');
                    pointVisible = false;

                    $items.each(function () {
                        $currentItem = jQuery(this);

                        visible = false;

                        categories = $currentItem.data('cats');
                        if (isNaN(categories)) {
                            categoriesData = categories.split(',');
                        } else {
                            categoriesData = [categories];
                        }
                        categoriesData = categoriesData.map(Number);
                        numCats = categoriesData.length;
                        for (j=0; j<numCats; j++) {
                            if (_catsActives.indexOf(categoriesData[j]) >= 0) {
                                visible = true;
                            }
                        }

                        if (visible) {
                            pointVisible = true;
                            $currentItem.show();
                        } else {
                            $currentItem.hide();
                        }



                    });

                    if (pointVisible) {
                        //$currentPoint.show();
                        $currentPoint.css('visibility','visible');
                    } else {
                        //$currentPoint.hide();
                        $currentPoint.removeClass('active');
                        $currentPoint.css('visibility','hidden');

                    }
                });

            },

            getCurrentCategory: function() {
                // console.log('_catsActives', _catsActives);

                return _catsActives.length ? _catsActives[0] : null;
            }
        };
    }


    return {

        getInstance: function() {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
